// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const uploadFile = async (formData: FormData) => {
  const uploadURL = "https://admin-api.snapcollars.com.au/upload"

  console.log(formData)

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment
  const data = await fetch(uploadURL, {
    method: "POST",
    body: formData
  })
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    .then(res => res.json())
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .then(data => data)
    .catch(() => {
      return null
    })

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return data
}
